<template>
  <div>
    <page-header :title="$t('scope.opensource_list')" :tabs="tabs" :current-tab.sync="currentTab" />
    <page-body>
      <keep-alive>
        <chart v-if="currentTab === 'chart'" :dayType="dayType" :changeDayType="changeDayType" />
        <list v-else :id="listId" :dayType="dayType" :changeDayType="changeDayType" />
      </keep-alive>
    </page-body>
  </div>
</template>

<script>
import List from './components/List'
import Chart from './components/Chart'

export default {
  name: 'OpensourceReportsIndex',
  components: {
    List,
    Chart,
  },
  data () {
    return {
      listId: 'OpensourceReportsList',
      dayType: '30',
      tabs: [
        {
          key: 'chart',
          label: '图',
        },
        {
          key: 'report',
          label: '表',
        },
      ],
      currentTab: 'chart',
    }
  },
  methods: {
    changeDayType (val) {
      this.dayType = val
    },
  },
}
</script>
